import { render, staticRenderFns } from "./SystemWidget.vue?vue&type=template&id=63da4c2a&scoped=true"
import script from "./SystemWidget.vue?vue&type=script&lang=js"
export * from "./SystemWidget.vue?vue&type=script&lang=js"
import style0 from "./SystemWidget.vue?vue&type=style&index=0&id=63da4c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da4c2a",
  null
  
)

export default component.exports